// extracted by mini-css-extract-plugin
export var fileUpload = "_gs-1";
export var modalButton = "_gs-0";